import { render, staticRenderFns } from "./HSCodeEditAdmin.vue?vue&type=template&id=b518db2c&scoped=true"
import script from "./HSCodeEditAdmin.vue?vue&type=script&lang=js"
export * from "./HSCodeEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b518db2c",
  null
  
)

export default component.exports